import request from '../utils/request'

// Thin wrapper around the /api/v1/discounts endpoints. The backend is the
// source of truth for validation (scope, expiry, limits, Stripe sync); the
// admin UI only presents + submits.
export const DiscountService = {
  list: async (params = {}) => {
    const { data } = await request.get('/discounts', { params })
    return data?.discounts || []
  },

  get: async (id) => {
    const { data } = await request.get(`/discounts/${id}`)
    return data?.discount
  },

  create: async (payload) => {
    const { data } = await request.post('/discounts', payload)
    return data?.discount
  },

  update: async (id, payload) => {
    const { data } = await request.patch(`/discounts/${id}`, payload)
    return data?.discount
  },

  deactivate: async (id) => {
    const { data } = await request.delete(`/discounts/${id}`)
    return data?.discount
  },

  redemptions: async (id) => {
    const { data } = await request.get(`/discounts/${id}/redemptions`)
    return data?.redemptions || []
  },

  preview: async (payload) => {
    const { data } = await request.post('/discounts/preview', payload)
    return data
  },
}

export default DiscountService
